/* tslint:disable */ // disabled for `any` types

// Function that does better handling of `data || defaultVal` esp when data is 0 or false intentionally
export default function coalesce(...values: Array<any>): any {
  const len = values.length;
  for (let i = 0; i < len; i++) {
    const value = values[i];
    if (value !== undefined && value !== null && !Number.isNaN(value)) {
      return value;
    }
  }

  return values[len - 1] || null;
}
